import { isEmptyString } from '../../lib/utils';
import { getTranslation } from '../../lib/reactUtils';
import { EmailSettings, EmailTemplate, EmailTemplateStatus, EmailTemplateStatusType } from './types';

export const getEmailTemplateStatus = (
  statusType: EmailTemplateStatusType, 
  template: EmailTemplate, 
  templateHTML?: string, 
  emailSettingsUnsaved?: EmailSettings, 
  emailSettingsError?: EmailSettings,
  emailSettingsIsUnsaved?: boolean,
): EmailTemplateStatus => {
  let messages: React.ReactNode[] = [];

  const senderNameError = getTranslation('email_templates.icon_tooltip.sender_name_error');
  const senderEmailError = getTranslation('email_templates.icon_tooltip.sender_email_error');
  const htmlError = getTranslation('email_templates.icon_tooltip.html_error');

  switch (statusType) {
    case 'card':
      if (isEmptyString(template.senderName)) {
        messages = [...messages, senderNameError];
      }
      if (isEmptyString(template.senderEmail)) {
        messages = [...messages, senderEmailError];
      }
      if (template.isEmptyHtml) {
        messages = [...messages, htmlError];
      }
      break;
    case 'subheader':
      if (emailSettingsIsUnsaved) {
        if (isEmptyString(emailSettingsUnsaved?.senderName)) {
          messages = [...messages, senderNameError];
        }
        if (isEmptyString(emailSettingsUnsaved?.senderEmail)) {
          messages = [...messages, senderEmailError];
        } else if (!isEmptyString(emailSettingsError?.senderEmail)) {
          messages = [...messages, senderEmailError];
        }
      } else {
        if (isEmptyString(template?.senderName)) {
          messages = [...messages, senderNameError];
        }
        if (isEmptyString(template?.senderEmail)) {
          messages = [...messages, senderEmailError];
        }
      }
      if (isEmptyString(templateHTML)) {
        messages = [...messages, htmlError];
      }
      break;
  }

  const emailTemplateStatus = {
    ...template,
    errorMessages: messages,
  };

  return emailTemplateStatus;
};
